const { Dispatcher } = require('flux');
const {
  CAT_CONTENT_FETCHED,
  FLOW_CONTENT_COMPLETED,
  FLOW_INPUT_COMPLETED,
  FLOW_LOADED,
  FLOW_PAGE_COMPLETED,
  FLOW_QUESTION_COMPLETED,
  GOTO_NODE,
  INPUT_CHANGED,
  INPUT_REGISTRATION_COMPLETED,
  INPUT_VALIDATION_FAILED
} = require('src/config/actions');

const PPFDispatcher = new Dispatcher();

const declareAction = ([fnName, actionName]) => ({
  [fnName]: (data) => PPFDispatcher.dispatch({ type: actionName, data })
});

const declareActions = (mapping) => {
  const actions = Object.entries(mapping).map(declareAction);
  return Object.assign(...actions);
};

const actions = declareActions({
  fireContentCompletedAction: FLOW_CONTENT_COMPLETED,
  fireCatContentFetchedAction: CAT_CONTENT_FETCHED,
  fireGoToNodeAction: GOTO_NODE,
  fireFlowLoadedAction: FLOW_LOADED,
  fireInputCompletedAction: FLOW_INPUT_COMPLETED,
  fireInputValidationFailedAction: INPUT_VALIDATION_FAILED,
  fireInputStoreDataAction: INPUT_CHANGED,
  fireInputRegistrationCompletedAction: INPUT_REGISTRATION_COMPLETED,
  firePageCompletedAction: FLOW_PAGE_COMPLETED,
  fireQuestionCompletedAction: FLOW_QUESTION_COMPLETED
});

module.exports = Object.assign({}, { PPFDispatcher }, actions);
